exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-promo-message {\n  display: block;\n}\n\n  upd-promo-message > ng-transclude {\n    color: #f84e57;\n  }\n", ""]);

